module.exports = __webpack_public_path__ + "static/img/p3.de0c9e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/hollo/p3.png
// module id = VsQa
// module chunks = 0